import { Component, forwardRef, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgxFileDropEntry, NgxFileDropModule } from 'ngx-file-drop';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { SkeletonModule } from 'primeng/skeleton';
import { AbstractView } from '@core/interfaces';
import { ImagePickerPresenter } from './image-picker.presenter';
import { SharedModule } from '@shared/shared.module';
import { ImagePickerViewPresenter } from './interfaces';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-image-picker',
  standalone: true,
  imports: [SharedModule, ButtonModule, NgxFileDropModule, SkeletonModule],
  templateUrl: './image-picker.component.html',
  styleUrl: './image-picker.component.scss',
  providers: [
    ImagePickerPresenter,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ImagePickerComponent),
      multi: true,
    },
  ],
})
export class ImagePickerComponent
  extends AbstractView<ImagePickerPresenter>
  implements ImagePickerViewPresenter, ControlValueAccessor, OnInit
{
  filesToUpload = this.presenter.filesToUpload;
  @Input({ required: true }) loading$ = this.presenter.loading$;
  @Input() editMode$ = this.presenter.editMode$;
  @Output() actionOnDroppedTriggered = this.presenter.actionOnDroppedTriggered;
  @Output() actionOnRemovedTriggered = this.presenter.actionOnRemovedTriggered;
  @Output() actionOnErrorTriggered = this.presenter.actionOnErrorTriggered;

  constructor(
    messageService: MessageService,
    router: Router,
    store: Store,
    presenter: ImagePickerPresenter
  ) {
    super(messageService, router, store, presenter);
  }
  
  ngOnInit(): void {
    this.presenter.setView(this);
  }

  // Propiedad enlazada a [(ngModel)]
  private _value: string|File|null|undefined = '';
  private _image: string|null|undefined = '';

  // Callbacks para ControlValueAccessor
  private onChange: (_: string|File|null|undefined) => void = () => {};
  private onTouched: () => void = () => {};

  get value(): string|File|null|undefined {
    return this._value;
  }

  set value(value: string|File|null|undefined) {
    this._value = value;
    this.onChange(value); // Notificamos cambios
  }

  get image(): string|null|undefined {
    return this._image;
  }

  set image(value: string|null|undefined) {
    this._image = value;
  }
  
  // Implementación de ControlValueAccessor
  writeValue(value: string|File|null|undefined): void {
    this.presenter.writeValue(value);
  }

  registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  onDroppedImage(files: NgxFileDropEntry[]): void {
    this.presenter.onDroppedImage(files);
  }

  onRemoveImage(): void {
    this.presenter.onRemoveImage();
  }

  onErrorImage(): void {
    this.presenter.onErrorImage();
  }
}
